import ApplyRecipeInfo from './ApplyRecipeInfo';

export default ApplyRecipeInfo;
